"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindingParser = void 0;
var ResultBox_1 = require("./Models/ResultBox");
var Property_1 = require("./Models/Property");
var ValueType_1 = require("./Models/ValueType");
var PropertyValue_1 = require("./Models/PropertyValue");
var ResultBoxType_1 = require("./Models/ResultBoxType");
var im = require("./image-defaults/imageNone.jpg");
var BindingParser = /** @class */ (function () {
    function BindingParser() {
    }
    //cette methode devra prendre le premier sujet dans la requete comme titre principal
    BindingParser.prototype.identifyMainTitleColumn = function (query, bindings) {
        // Vérifier si la requête est disponible et si elle contient des variables
        if (!query || !query.variables || query.variables.length === 0) {
            console.error("Aucune variable trouvée dans la requête.");
            return undefined;
        }
        // Vérifier si la requête contient des branches
        if (!query.branches || query.branches.length === 0) {
            console.error("Aucune branche trouvée dans la requête.");
            return undefined;
        }
        // Vérifier si la première branche a un sujet
        if (!query.branches[0].line || !query.branches[0].line.s) {
            console.error("Aucun sujet trouvé dans la première branche de la requête.");
            return undefined;
        }
        // Retourner le sujet de la première branche comme titre principal
        console.log("Main title column:", query.branches[0].line.s);
        return query.branches[0].line.s;
    };
    //OK
    //methode qui va permettre de recuperer le couple titre principal et l'uri
    BindingParser.prototype.extractMainTitleAndURI = function (bindingSet, principalColumnTitle) {
        var _a, _b;
        var mainTitle = "";
        var mainURI = "";
        //verifier si la colonne du titre principal existe
        if (principalColumnTitle && bindingSet[principalColumnTitle]) {
            var value_1 = bindingSet[principalColumnTitle];
            // try to find the label key if x-labelled-uri, otherwise take the value key
            mainTitle = (_a = (value_1.label ? value_1.label : value_1.value)) !== null && _a !== void 0 ? _a : "";
            mainURI = (_b = value_1.value) !== null && _b !== void 0 ? _b : "";
        }
        //we are ensure that at the return we will have a title and an uri
        return { title: mainTitle, uri: mainURI };
    };
    //OK
    // Méthode pour identifier la colonne de l'image principale
    BindingParser.prototype.identifyPrincipalImageColumn = function (query, bindings) {
        if (query && query.branches && query.branches.length > 0) {
            // Parcourir chaque branche de premier niveau de la requête
            for (var _i = 0, _a = query.branches; _i < _a.length; _i++) {
                var branch = _a[_i];
                // Vérifier si la branche a un sujet (objet principal)
                if (branch.line && branch.line.s) {
                    // Vérifier si la branche a une colonne "o" qui appartient directement à l'objet principal
                    if (branch.line.o &&
                        this.columnHasImageValues(branch.line.o, bindings)) {
                        return branch.line.o;
                    }
                }
            }
        }
        return undefined;
    };
    //OK
    // Méthode pour vérifier si une colonne a des valeurs qui sont des URI d'image
    BindingParser.prototype.columnHasImageValues = function (column, bindings) {
        // Parcourir les bindings
        for (var _i = 0, _a = bindings.slice(0, 10); _i < _a.length; _i++) {
            var bindingSet = _a[_i];
            var value_2 = bindingSet[column];
            // Vérifier si la valeur est une URI d'image
            if (value_2 && value_2.type === "uri" && this.isImageURI(value_2.value)) {
                return true;
            }
        }
        return false;
    };
    //OK
    //verifier si une uri est une uri d'image ou non RegularExpression
    BindingParser.prototype.isImageURI = function (uri) {
        if (!uri) {
            return false;
        }
        return uri.match(/\.(jpg|jpeg|png|svg)(\?.*)?$/i) !== null;
    };
    //OK
    // une fois trouver la colonne de l'image principale on va extraire l'uri de l'image sur le bindingset
    //partie lecture
    //methode appelée dans la methode extractResultData
    BindingParser.prototype.extractMainImageURI = function (bindingSet, principalColumnImage) {
        var value = { value: "" };
        if (principalColumnImage && bindingSet) {
            if (bindingSet[principalColumnImage]) {
                value = bindingSet[principalColumnImage];
                return value.value;
            }
            else {
                return im;
            }
        }
        return undefined;
    };
    //OK
    // Méthode pour récupérer le label des prédicats en utilisant les branches de la query
    BindingParser.prototype.getPredicate = function (query, queryConfiguration) {
        // Initialiser un objet pour stocker les prédicats et les types d'objets
        var predicates = {};
        // Parcourir les branches de la query
        for (var _i = 0, _a = query.branches; _i < _a.length; _i++) {
            var branch = _a[_i];
            // Appeler la méthode searchInBranch pour chaque branche
            this.searchInBranch(branch, predicates, queryConfiguration, query);
        }
        return predicates;
    };
    //OK
    // Méthode pour parcourir les branches et les enfants pour trouver les prédicats
    BindingParser.prototype.searchInBranch = function (branch, predicates, queryConfiguration, query) {
        var line = branch.line;
        // Ajouter le prédicat pour la propriété `o` de la branche
        if (line && line.o) {
            //recuperer le libelle du prédicat en utilisant la methode getLabelpre
            var predicateLabel = this.getLabelpre(line.p, queryConfiguration);
            predicates[line.o] = predicateLabel;
        }
        // Ajouter également le sujet si nécessaire (cette partie est optionnelle)
        if (line && line.s && !(line.s in predicates)) {
            predicates[line.s] = "";
        }
        // Parcourir les enfants de la branche recursivement
        if (branch.children && branch.children.length > 0) {
            for (var _i = 0, _a = branch.children; _i < _a.length; _i++) {
                var child = _a[_i];
                this.searchInBranch(child, predicates, queryConfiguration, query);
            }
        }
    };
    //OK
    // Méthode pour retourner le label du prédicat en prenant le prédicat comme paramètre
    BindingParser.prototype.getLabelpre = function (predicateURI, queryConfiguration) {
        if (queryConfiguration &&
            typeof queryConfiguration.getProperty === "function") {
            // Récupérer le label du predicat avec la méthode getProperty et ensuite getLabel
            var objectType = queryConfiguration.getProperty(predicateURI);
            if (objectType) {
                return objectType.getLabel() || predicateURI;
            }
            else {
                return predicateURI;
            }
        }
        else {
            return predicateURI;
        }
    };
    //OK
    // Méthode pour récupérer les prédicats URIs en utilisant les branches de la query
    BindingParser.prototype.getPredicateURI = function (query, queryConfiguration) {
        // Initialiser un objet pour stocker les prédicats et les types d'objets
        var predicates = {};
        // Parcourir les branches de la query
        for (var _i = 0, _a = query.branches; _i < _a.length; _i++) {
            var branch = _a[_i];
            this.searchInBranchURI(branch, predicates, queryConfiguration, query);
        }
        return predicates;
    };
    //OK
    // Méthode pour parcourir les branches et les enfants pour trouver les prédicats URI
    BindingParser.prototype.searchInBranchURI = function (branch, predicates, queryConfiguration, query) {
        var line = branch.line;
        // Ajouter le prédicat pour la propriété `o` de la branche
        // Ajouter une condition pour vérifier si le predicates[line.o] est présent dans les variables de la query
        // Si oui, on récupère l'URI du prédicat
        if (line && line.o) {
            predicates[line.o] = line.p;
        }
        // Ajouter également le sujet si nécessaire
        if (line && line.s && !(line.s in predicates)) {
            predicates[line.s] = "";
        }
        // Parcourir les enfants de la branche
        if (branch.children && branch.children.length > 0) {
            for (var _i = 0, _a = branch.children; _i < _a.length; _i++) {
                var child = _a[_i];
                this.searchInBranchURI(child, predicates, queryConfiguration, query);
            }
        }
    };
    //OK
    // Méthode pour récupérer le label des objets en utilisant les branches de la query
    BindingParser.prototype.getObject = function (query, queryConfiguration) {
        // Initialiser un objet pour stocker les objets et leurs types
        var objects = {};
        // Parcourir les branches de la query
        for (var _i = 0, _a = query.branches; _i < _a.length; _i++) {
            var branch = _a[_i];
            this.searchObjectInBranch(branch, objects, queryConfiguration, query);
        }
        return objects;
    };
    //OK
    // Méthode pour parcourir les branches et les enfants pour trouver les objets
    BindingParser.prototype.searchObjectInBranch = function (branch, objects, queryConfiguration, query) {
        var line = branch.line;
        // Ajouter l'objet pour la propriété `o` de la branche
        if (line &&
            line.o &&
            query.variables.find(function (variable) { return variable.value === line.o; })) {
            var objectTypeLabel = this.getEntityLabel(line.oType, queryConfiguration);
            objects[line.o] = objectTypeLabel;
        }
        // Ajouter également le sujet si nécessaire
        if (line && line.s && !(line.s in objects)) {
            var subjectTypeLabel = this.getEntityLabel(line.sType, queryConfiguration);
            objects[line.s] = subjectTypeLabel;
        }
        // Parcourir les enfants de la branche recursivement
        if (branch.children && branch.children.length > 0) {
            for (var _i = 0, _a = branch.children; _i < _a.length; _i++) {
                var child = _a[_i];
                this.searchObjectInBranch(child, objects, queryConfiguration, query);
            }
        }
    };
    //OK
    // Méthode pour retourner le label de l'objet en prenant l'URI de l'objet comme paramètre
    BindingParser.prototype.getEntityLabel = function (entityURI, queryConfiguration) {
        if (queryConfiguration &&
            typeof queryConfiguration.getProperty === "function") {
            // Récupérer le type de l'objet avec la méthode getProperty
            var object = queryConfiguration.getEntity(entityURI);
            if (object) {
                return object.getLabel() || entityURI;
            }
            else {
                return entityURI;
            }
        }
        else {
            return entityURI;
        }
    };
    //OK
    // Méthode pour récupérer les objets en utilisant les branches de la query
    BindingParser.prototype.getObjectUri = function (query, queryConfiguration) {
        // Initialiser un objet pour stocker les objets et leurs types
        var objects = {};
        // Parcourir les branches de la query
        for (var _i = 0, _a = query.branches; _i < _a.length; _i++) {
            var branch = _a[_i];
            this.searchObjectInBranchURI(branch, objects, queryConfiguration, query);
        }
        return objects;
    };
    //OK
    // Méthode pour parcourir les branches et les enfants pour trouver les objets
    BindingParser.prototype.searchObjectInBranchURI = function (branch, objects, queryConfiguration, query) {
        var line = branch.line;
        // Ajouter l'objet pour la propriété `o` de la branche
        if (line &&
            line.o &&
            query.variables.find(function (variable) { return variable.value === line.o; })) {
            objects[line.o] = line.oType;
        }
        // Ajouter également le sujet si nécessaire
        if (line && line.s && !(line.s in objects)) {
            objects[line.s] = line.sType;
        }
        // Parcourir les enfants de la branche recursivement
        if (branch.children && branch.children.length > 0) {
            for (var _i = 0, _a = branch.children; _i < _a.length; _i++) {
                var child = _a[_i];
                this.searchObjectInBranchURI(child, objects, queryConfiguration, query);
            }
        }
    };
    //OK
    // Méthode pour lire les propriétés pour une les bindingSet
    // a voir pour changer la logique de la methode (...rest)
    BindingParser.prototype.readProperties = function (query, queryConfig, bindingSet, predicates, objects) {
        var propertiesList = [];
        // Lire les propriétés pour chaque branche du query
        for (var _i = 0, _a = query.branches; _i < _a.length; _i++) {
            var branch = _a[_i];
            var properties = this.readPropertyForLine(branch, bindingSet, query, queryConfig, predicates, objects);
            propertiesList.push.apply(propertiesList, properties); // Ajouter les propriétés à propertiesList
        }
        // Récupérer l'ordre des variables à partir de query.variables
        var variableOrder = query.variables.map(function (variable) { return variable.value; });
        //const variableOR = variableOrder.slice(1);
        // Ordonner les propriétés en fonction de l'ordre des variables
        var ordredpropertiesList = [];
        //appeler la methode ordredpropertiesListfun pour ordonner les propriétés en fonction de l'ordre de la configuration
        ordredpropertiesList = this.ordredpropertiesListfun(variableOrder, propertiesList);
        return ordredpropertiesList; // Retourner la liste ordonnée des propriétés
    };
    //OK
    //methode qui va permettre de trier les propriétés en fonction de l'ordre de la configuration de la requête
    BindingParser.prototype.ordredpropertiesListfun = function (variableOrder, propertiesList) {
        // Séparer les propriétés en deux listes : celles qui sont dans variableOrder et celles qui ne le sont pas
        var inOrderProperties = [];
        var outOfOrderProperties = [];
        //scinder les propriétés en deux listes celles qui sont presentes dans variableOrder et celles qui ne le sont pas
        for (var _i = 0, propertiesList_1 = propertiesList; _i < propertiesList_1.length; _i++) {
            var property = propertiesList_1[_i];
            if (variableOrder.includes(property.column)) {
                inOrderProperties.push(property);
            }
            else {
                outOfOrderProperties.push(property);
            }
        }
        // Trier les propriétés qui sont dans variableOrder
        //une fois les propriétés scindées on va les trier en fonction de l'ordre de variableOrder
        //au retour on aura sortedInOrderProperties qui contient les propriétés triées en fonction de l'ordre de variableOrder
        var sortedInOrderProperties = inOrderProperties.sort(function (a, b) {
            var aIndex = variableOrder.indexOf(a.column);
            var bIndex = variableOrder.indexOf(b.column);
            return aIndex - bIndex;
        });
        //de meme facon pour les fils
        // Trier récursivement les fils de chaque propriété
        for (var _a = 0, sortedInOrderProperties_1 = sortedInOrderProperties; _a < sortedInOrderProperties_1.length; _a++) {
            var property = sortedInOrderProperties_1[_a];
            for (var _b = 0, _c = property.values; _b < _c.length; _b++) {
                var value_3 = _c[_b];
                if (value_3.predicates.length > 0) {
                    value_3.predicates = this.ordredpropertiesListfun(variableOrder, value_3.predicates);
                }
            }
        }
        // Trier récursivement les fils des propriétés hors ordre
        for (var _d = 0, outOfOrderProperties_1 = outOfOrderProperties; _d < outOfOrderProperties_1.length; _d++) {
            var property = outOfOrderProperties_1[_d];
            for (var _e = 0, _f = property.values; _e < _f.length; _e++) {
                var value_4 = _f[_e];
                if (value_4.predicates.length > 0) {
                    value_4.predicates = this.ordredpropertiesListfun(variableOrder, value_4.predicates);
                }
            }
        }
        // Combiner les deux listes : les propriétés en ordre d'abord, puis les hors ordre
        return __spreadArray(__spreadArray([], sortedInOrderProperties, true), outOfOrderProperties, true);
    };
    //OK
    // Méthode pour lire les propriétés pour une branche donnée
    BindingParser.prototype.readPropertyForLine = function (branch, bindingSet, query, queryConfig, predicates, objects) {
        var _this = this;
        var _a, _b, _c, _d;
        var propertiesList = [];
        // Add null check for branch.line
        if (!branch || !branch.line) {
            return propertiesList;
        }
        var objectVariable = branch.line.o;
        var value = this.getValueFromBindings(bindingSet, objectVariable);
        var predicatesURI = this.getPredicateURI(query, queryConfig);
        var objectU = this.getObjectUri(query, queryConfig);
        var valuesArray = [];
        // si la valeur est un x-labelled-uri on va l'ajouter dans le tableau des valeurs
        if (value !== undefined &&
            (value === null || value === void 0 ? void 0 : value.label) !== undefined &&
            (value === null || value === void 0 ? void 0 : value.type) === "x-labelled-uri") {
            // Ajouter la valeur à valuesArray
            valuesArray.push(new PropertyValue_1.PropertyValue((_a = value.label) !== null && _a !== void 0 ? _a : "", value.value, []));
        }
        if ((value === null || value === void 0 ? void 0 : value.value) !== undefined &&
            (value === null || value === void 0 ? void 0 : value.label) === undefined &&
            ((value === null || value === void 0 ? void 0 : value.type) === "literal" || (value === null || value === void 0 ? void 0 : value.type) === "typed-literal")) {
            valuesArray.push(new PropertyValue_1.PropertyValue((_b = value.value) !== null && _b !== void 0 ? _b : "", "", []));
        }
        if ((value === null || value === void 0 ? void 0 : value.type) === "uri" &&
            (value === null || value === void 0 ? void 0 : value.value) !== undefined &&
            !this.isImageURI(value.value)) {
            valuesArray.push(new PropertyValue_1.PropertyValue(value.value, value.value, []));
        }
        var predicate = new Property_1.Property("", valuesArray, new ValueType_1.ValueType("", ""), "", objectVariable);
        // Skip the property if value type is "ImageUri"
        if (!this.isImageURI(value === null || value === void 0 ? void 0 : value.value)) {
            predicate = new Property_1.Property((_c = predicates[objectVariable]) !== null && _c !== void 0 ? _c : "", valuesArray, new ValueType_1.ValueType(objectU[objectVariable], objects[objectVariable]), (_d = predicatesURI[objectVariable]) !== null && _d !== void 0 ? _d : "", objectVariable);
        }
        if (branch.children && branch.children.length > 0) {
            var childrenProperties = branch.children.flatMap(function (child) {
                return _this.readPropertyForLine(child, bindingSet, query, queryConfig, predicates, objects);
            });
            // Ajouter les propriétés enfants en tant que prédicats dans les PropertyValue de la propriété courante
            //faut verifier si la valeur est indefinie ou non
            if (value === undefined) {
                // Si la valeur est indéfinie, ajouter directement les enfants comme valeurs
                var valueWithChildren = new PropertyValue_1.PropertyValue("", "", []);
                for (var _i = 0, childrenProperties_1 = childrenProperties; _i < childrenProperties_1.length; _i++) {
                    var childProp = childrenProperties_1[_i];
                    valueWithChildren.addPredicate(childProp);
                }
                predicate.addValue(valueWithChildren);
            }
            else {
                // Si la valeur est définie, ajouter les enfants comme prédicats des PropertyValue
                for (var _e = 0, _f = predicate.values; _e < _f.length; _e++) {
                    var val = _f[_e];
                    for (var _g = 0, childrenProperties_2 = childrenProperties; _g < childrenProperties_2.length; _g++) {
                        var childProp = childrenProperties_2[_g];
                        val.addPredicate(childProp);
                    }
                }
            }
        }
        // Add the predicate only if it's not of type "uri"
        if (!this.isImageURI(value === null || value === void 0 ? void 0 : value.value)) {
            propertiesList.push(predicate);
        }
        return propertiesList;
    };
    // OK
    //recuperer la valeur d'une variable dans les bindings
    BindingParser.prototype.getValueFromBindings = function (bindingSet, variable) {
        for (var _i = 0, bindingSet_1 = bindingSet; _i < bindingSet_1.length; _i++) {
            var values = bindingSet_1[_i];
            if (values.hasOwnProperty(variable)) {
                return values[variable];
            }
        }
        return undefined;
    };
    //OK
    //methode qui va permettre de fusionner les proprietes appartenant au meme objet principal
    BindingParser.prototype.mergeProperties = function (existingProperty, newProperty) {
        var _loop_1 = function (newValue) {
            // Try to find a matching existing value
            var existingValue = existingProperty.values.find(function (value) {
                return (value.label && newValue.label && value.label === newValue.label) ||
                    (value.uri && newValue.uri && value.uri === newValue.uri) ||
                    value.id === newValue.id;
            });
            if (existingValue) {
                var _loop_2 = function (predicate) {
                    var existingPredicate = existingValue.predicates.find(function (p) { return p.uri === predicate.uri; });
                    if (existingPredicate) {
                        // If a matching predicate is found, merge its children recursively
                        this_1.mergeProperties(existingPredicate, predicate);
                    }
                    else {
                        // If no matching predicate is found, add the new predicate
                        existingValue.predicates.push(predicate);
                    }
                };
                // If a matching value is found, merge the predicates and children recursively
                for (var _b = 0, _c = newValue.predicates; _b < _c.length; _b++) {
                    var predicate = _c[_b];
                    _loop_2(predicate);
                }
            }
            else {
                // If no matching value is found, add the new value
                existingProperty.values.push(newValue);
            }
        };
        var this_1 = this;
        // Iterate over the values of the new property
        for (var _i = 0, _a = newProperty.values; _i < _a.length; _i++) {
            var newValue = _a[_i];
            _loop_1(newValue);
        }
    };
    //OK
    // cette methode permet d'extraire l'uri du type de document à partir de la query
    BindingParser.prototype.extractDocumentTypeURIFromQuery = function (branches) {
        for (var _i = 0, branches_1 = branches; _i < branches_1.length; _i++) {
            var branch = branches_1[_i];
            if (branch && branch.line && branch.line.sType) {
                return branch.line.sType;
            }
        }
        return undefined;
    };
    //OK
    // cette methode permet de recuperer le libéllé du type de document en utilisant son uri
    BindingParser.prototype.getDocumentTypeLabel = function (documentTypeURI, queryConfiguration) {
        if (queryConfiguration &&
            typeof queryConfiguration.getEntity === "function") {
            var entity = queryConfiguration.getEntity(documentTypeURI);
            if (entity) {
                return entity.getLabel() || documentTypeURI;
            }
            else {
                return documentTypeURI;
            }
        }
        else {
            return documentTypeURI;
        }
    };
    /**
     *
     * @param documentTypeURI
     * @param queryConfiguration
     * @returns l'icone du type de document en utilisant son uri, ou bien undefined s'il n'y a pas d'icône
     */
    BindingParser.prototype.getDocumentTypeIconClass = function (documentTypeURI, queryConfiguration) {
        if (queryConfiguration &&
            typeof queryConfiguration.getEntity === "function") {
            var entity = queryConfiguration.getEntity(documentTypeURI);
            if (entity) {
                return entity.getIcon() || undefined;
            }
            else {
                return undefined;
            }
        }
        else {
            return undefined;
        }
    };
    //OK
    //The main methode of this class
    //this methode will use all the previous methode to extract the result data and return our data structure ResultBoxM[]
    BindingParser.prototype.extractResultData = function (bindings, query, queryConfig) {
        // Initialiser un tableau pour stocker les ResultBoxM
        var resultBoxes = [];
        // Vérifier si la query et la configuration de la query sont disponibles
        if (!query && !queryConfig) {
            console.error("No query found");
            return [];
        }
        //recuperer l'URI du type de document
        var documentTypeURI = this.extractDocumentTypeURIFromQuery(query.branches);
        //recuperer le libéllé du type de document
        var documentTypeLabel = documentTypeURI
            ? this.getDocumentTypeLabel(documentTypeURI, queryConfig)
            : "";
        //recuperer l'icone du type de document
        var documentTypeIcon = this.getDocumentTypeIconClass(documentTypeURI !== null && documentTypeURI !== void 0 ? documentTypeURI : "", queryConfig);
        //creer un objet ResultBoxType "type de la boite de resultat"
        var type = new ResultBoxType_1.ResultBoxType(documentTypeURI !== null && documentTypeURI !== void 0 ? documentTypeURI : "", documentTypeLabel, documentTypeIcon !== null && documentTypeIcon !== void 0 ? documentTypeIcon : "");
        //search for the principal title column
        var principalColumnTitle = this.identifyMainTitleColumn(query, bindings);
        //search for the principal image column
        var principalColumnImage = this.identifyPrincipalImageColumn(query, bindings);
        //get the predicates columns {o: p.label}
        var predicatesColumnLabel = this.getPredicate(query, queryConfig);
        //get the objects columns {o: oType.label}
        var objectsColumnLabel = this.getObject(query, queryConfig);
        //map to store the result boxes by title "Merged solution"
        var titleMap = {};
        //parcourir les bindings pour extraire les resultats
        for (var _i = 0, bindings_1 = bindings; _i < bindings_1.length; _i++) {
            var bindingSet = bindings_1[_i];
            //extraire le titre principal et l'uri
            var _a = this.extractMainTitleAndURI(bindingSet, principalColumnTitle), title = _a.title, uri = _a.uri;
            //extraire les prédicats
            var predicates = this.readProperties(query, queryConfig, [bindingSet], predicatesColumnLabel, objectsColumnLabel);
            //extraire l'uri de l'image principale
            var imageURI = this.extractMainImageURI(bindingSet, principalColumnImage);
            //merger les resultats par titre "Merged solution"
            if (uri in titleMap && title !== "") {
                var existingBox = titleMap[uri];
                var _loop_3 = function (predicate) {
                    var existingPredicate = existingBox.predicates.find(function (p) { return p.uri === predicate.uri; });
                    if (existingPredicate) {
                        this_2.mergeProperties(existingPredicate, predicate);
                    }
                    else {
                        existingBox.predicates.push(predicate);
                    }
                };
                var this_2 = this;
                for (var _b = 0, predicates_1 = predicates; _b < predicates_1.length; _b++) {
                    var predicate = predicates_1[_b];
                    _loop_3(predicate);
                }
                if (imageURI && !existingBox.image) {
                    existingBox.image = imageURI;
                }
            }
            else {
                if (title !== "") {
                    //creer un objet ResultBoxM pour chaque titre
                    var resultBox = new ResultBox_1.ResultBoxM(type, title, uri, imageURI !== null && imageURI !== void 0 ? imageURI : "", predicates);
                    //maper le resultBox par titre "Merged solution"
                    titleMap[uri] = resultBox;
                }
            }
        }
        //ajouter les resultats de la mergedMaps dans le tableau des resultats
        for (var uri in titleMap) {
            resultBoxes.push(titleMap[uri]);
        }
        //
        //retourner les resultats 'Vérification'
        console.log("Result boxes", resultBoxes);
        return resultBoxes;
    };
    return BindingParser;
}());
exports.BindingParser = BindingParser;
